import { endOfDay } from 'date-fns';
import { atom as atomJ } from 'jotai';
import { atomFamily as atomFamilyJ } from 'jotai-family';
import { Temporal } from 'temporal-polyfill';
import { fetchRoundTracker } from '../../../services/queries/MaggieMetricsQueries';
import { dateToPlainDateString } from '../../../util/date-utilts';

// ===== JOTAI STORE =====

export const roundTrackerMetricsByDateJ = atomFamilyJ((date?: Date) =>
  atomJ(async () => {
    const today = endOfDay(new Date());
    const targetDate = date ?? today;

    const metrics = await fetchRoundTracker(dateToPlainDateString(targetDate));

    return metrics.filter((metric) => {
      return new Date(metric.investmentDate).getTime() < targetDate.getTime();
    });
  })
);

export const roundTrackerMetricsByCompanyIdJ = atomFamilyJ(
  (params: { date?: Date; companyId: number }) =>
    atomJ(async () => {
      const { date, companyId } = params;
      const asOfDate = date ? dateToPlainDateString(date) : Temporal.Now.plainDateISO().toString();
      return await fetchRoundTracker(asOfDate, undefined, [companyId]);
    }),
  (a, b) => a.companyId === b.companyId && a.date?.getTime() === b.date?.getTime()
);
